// extracted by mini-css-extract-plugin
module.exports = {"notifications":"styles_notifications__37ZoE","browser-ie":"styles_browser-ie__2BWDU","button":"styles_button__1_Bln"};